import angular from 'angular';

import HeaderModule from './header';
import FooterModule from './footer';
import TestimonialModule from './testimonial';
import WordSwitcherModule from './word-switcher';

export default angular
    .module('presentation.component', [
        HeaderModule.name,
        FooterModule.name,
        TestimonialModule.name,
        WordSwitcherModule.name
    ]);



// WEBPACK FOOTER //
// ./src/presentation/component/index.js